<template>
  <div>
    <EmployedDetail v-if="type == 'EmployeeDtail'" :model="object" :on-success="actions"/>

    <NominaEmpleadosDetail v-if="type == 'NominaEmpleadosDetail'" :model="object" :on-success="actions" />
    <HistoryMovements v-if="type == 'Movements'" :model="object" />

    <LogsAppDetail v-if="type == 'LogsApp'" :model="object" />
    <HorarioDetail v-if="type == 'HorarioColaborador'" :model="object" :on-success="actions" />
    <AsistenciaDetail v-if="type == 'AsistenciaColaborador'" :model="object" :on-success="actions" />
    <EjercicioDetail v-if="type == 'EjercicioDetail'" :model="object" :on-success="actions" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EmployedDetail from '@/components/details/EmpleadoDetail'
import NominaEmpleadosDetail from '@/components/details/NominaEmpleadosDetail'
import HistoryMovements from '@/components/details/HistoryMovements'
import LogsAppDetail from '@/components/details/LogsAppDetail'
import HorarioDetail from '@/components/details/HorarioDetail'
import AsistenciaDetail from '@/components/details/AsistenciaDetail'
import EjercicioDetail from '@/components/details/EjercicioDetail'
export default {
  props: ['object', 'type', 'itemsAction'],
  data: () => ({}),
  mounted () {},
  methods: {
    ...mapActions([]),
    ...mapMutations([]),
    actions (actons) {
      this.itemsAction(actons)
    }
  },
  computed: {
    ...mapGetters([])
  },
  components: {
    EmployedDetail,
    NominaEmpleadosDetail,
    HistoryMovements,
    LogsAppDetail,
    HorarioDetail,
    AsistenciaDetail,
    EjercicioDetail
  },
  watch: {},
  beforeDestroy () {}
}
</script>

<style>

</style>
